export default __webpack_public_path__ + "../staticImages/kuesser-260.png";